import request from '@/router/axios'

export function fetchList (query) {
  return request({
    url: '/admin/admin/complaint-category/page',
    method: 'get',
    params: query
  })
}

export function addObj (obj) {
  return request({
    url: '/admin/admin/complaint-category',
    method: 'post',
    data: obj
  })
}

export function putObj (obj) {
  return request({
    url: '/admin/admin/complaint-category',
    method: 'put',
    data: obj
  })
}
